import styled from "styled-components";
import { ThemeType } from "../../../types/Theme";

// ---- Card de aula (reutilizado na vitrine e na trilha) ----
export const CardAula = styled.div<{ theme: ThemeType }>`
  position: relative;
  width: 100%;
  height: 22rem;
  border-radius: 3rem;
  overflow: hidden;
  cursor: pointer;
  background-color: #2a2017;
  flex: 0 0 auto;

  .capa {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .barra-progresso {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 6px;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.25);
    z-index: 2;
    .preenchido {
      height: 100%;
      background-color: ${({ theme }) => theme.colors.secondary};
    }
  }
  &:hover .capa {
    transform: scale(1.04);
    transition: transform 0.3s ease;
  }
`;
